<template>
  <settings
    :setting-tabs="adminSettingTabs"
    v-bind="$props"
  >
    <!-- <team-icon-name :team="team" class="team-name" /> <span>admin</span>
     -->
    <team-icon
      :team="team"
      class="team-icon"
    />
    {{ team.name }}
    <span> {{ $t('roles'+'.'+role(team)) }}</span>
  </settings>
</template>

<script>
import Settings from '@/components/Settings'
import TeamIcon from '@/components/Team/TeamIcon'
import Constants from '@/components/Constants'

export default {
  components: {
    TeamIcon,
    Settings,
  },
  mixins: [Constants],
  props: {
    team: Object,
    initialTab: Object,
  },
  data() {
    return {
      adminSettingTabs: [],
      key: 1,
    }
  },
  created() {
    this.adminSettingTabs = this.teamSettingsTabs()
    this.$store.commit('setTeamRole',this.role(this.team))
  },
  methods:{
  },
}
</script>

<style lang="scss" scoped>
* {
  line-height: 26px;
}
.team-icon {
  float: left;
  zoom: 1.2;
  margin-right: 6px;
}
span {
  color: $bluebell;
  margin-left: 0px;
  font-family: $bold;
  vertical-align: baseline;
}
</style>
